import { Megaphone } from 'lucide-react';
import { CampaignsPage } from './routes/campaigns.js';
/**
 * Раздел «Кампании» пространства «Реклама» (контракт A2a, 03.11.2026): список
 * кампаний кабинета деревом «кампания → группы → объявления», пауза и включение
 * одного объекта и пачкой (только кампании) через admin-api
 * `/api/ads/accounts/:id/campaigns…`.
 *
 * Модуль отсоединяемый: импортирует только кит (`ui`, `ui-domain`),
 * `admin-client-core` и `admin-contracts` (ESLint allowlist). Модуль «Запуски FB»
 * НЕ импортируется: ссылки на его страницы — адреса (`/fb-launches/...`).
 * Права на действия — `AdsCampaignsModulePermsProvider` (шелл даёт флаги из
 * `me.permissions`): пауза — `ads.launch`, включение — `ads.activate`; без
 * провайдера действия закрыты (fail-closed), дубль-контроль — в admin-api.
 */
export const adsCampaignsModule = {
    id: 'campaigns',
    label: 'Кампании',
    icon: Megaphone,
    permission: 'ads.read',
    workspace: 'ads',
    order: 15,
    description: 'Кампании кабинета: найти объект, поставить на паузу, включить.',
    showInNav: true,
    sectionsPlacement: 'sidebar',
    routeChrome: 'shell',
    sections: [],
    routes: [{ path: '/', component: CampaignsPage }],
};
export { setAdsCampaignsApiBaseUrl } from './api.js';
export { ADS_CAMPAIGNS_NO_PERMS, AdsCampaignsModulePermsProvider, adsCampaignsPermsFrom, useAdsCampaignsPerms, } from './perms.js';
//# sourceMappingURL=index.js.map